import useWindowSize from 'hooks/useWindowSize';

import ECFLogo from 'assets/ECF/headerLogo.png';
import hippoLogo from 'assets/HippoCampus/hippo-logo.png';
import hippoSmall from 'assets/HippoCampus/hippo-small-logo.png';
import SSALogo from 'assets/SSA/SSALogo.png';

import peerTreeSmall from 'assets/images/peerTreeLogo.svg';
import peerTreeLogo from 'assets/images/peerTreeSmall.svg';

import fscLogo from 'assets/FSC/logo.png';
import { DOMAIN_KEYS } from 'common';

import CSMLogo from 'assets/CSM/logo.png';
import nucleusLogo from 'assets/Nucleus/logo.png';
import pearCoreLogo from 'assets/PearCore/logo.png';
import vanderbiltLogo from 'assets/Vanderbilt/logo.png';

import politicalIslamLogo from 'assets/PoliticalIslam/logo.png';

import mlkLogo from 'assets/Hrights/logo.png';
import meLogo from 'assets/ME/logo.png';

import emLogo from 'assets/EM/logo.png';
import fbaLogo from 'assets/FBA/fbaLogo.png';
import scoutLogo from 'assets/MH360/ScoutLogo.png';
import SAQLogo from 'assets/SAQ/SAQ-logo.png';
import spacesLogo from 'assets/Spaces/logo.png';
import tvgLogo from 'assets/TVGuest/logo.png';
import workVibesLogo from 'assets/WorkVibes/logo.png';

import SCREEN_SIZES from 'constants/screen-sizes';
import useGetDomainTracking from 'store/services/helperHooks/useGetDomainTracking';
import Image from 'style-guide/Image';

// TODO: add other customers here as well

const GetCustomersLogo = () => {
  const { innerWidth } = useWindowSize();
  const { data } = useGetDomainTracking();
  const isMobile = innerWidth < SCREEN_SIZES.MD;

  switch (data?.key) {
    case DOMAIN_KEYS.hippoCampus:
      return <Image className='hippo-logo logo' src={isMobile ? hippoSmall : hippoLogo} alt='hippo-campus' />;
    case DOMAIN_KEYS.ssa:
      return <Image className='ssa-logo logo' src={SSALogo} alt='ssa' />;
    case DOMAIN_KEYS.vanderbilt:
      return <Image className='vanderbilt-logo logo' src={vanderbiltLogo} alt='vanderbilt' />;
    case DOMAIN_KEYS.fsc:
      return <Image className='fsc-logo logo' src={fscLogo} alt='Freddie Scott' />;
    case DOMAIN_KEYS.hrights:
      return <Image className='mlk-logo logo' src={mlkLogo} alt='MLK' />;
    case DOMAIN_KEYS.nucleus:
      return <Image className='nucleus-logo logo' src={nucleusLogo} alt='Nucleus' />;
    case DOMAIN_KEYS.pear:
      return <Image className='pear-logo logo' src={pearCoreLogo} alt='Pear Core' />;
    case DOMAIN_KEYS.csm:
    case DOMAIN_KEYS.vaco:
      return <Image className='csm-logo logo' src={CSMLogo} alt='CSM' />;
    case DOMAIN_KEYS.politicalislam:
      return <Image className='political-islam-logo logo' src={politicalIslamLogo} alt='Political Islam' />;
    case DOMAIN_KEYS.ecf:
      return <Image className='ecf-logo logo' src={ECFLogo} alt='ECF' />;
    case DOMAIN_KEYS.workvibes:
      return <Image className='workvibes-logo logo' src={workVibesLogo} alt='workvibes' />;
    case DOMAIN_KEYS.me:
      return <Image className='me-logo logo' src={meLogo} alt='ME' />;
    case DOMAIN_KEYS.tvguest:
      return <Image className='tvg-logo logo' src={tvgLogo} alt='TVG' />;
    case DOMAIN_KEYS.spaces:
      return <Image className='spaces-logo logo' src={spacesLogo} alt='e|spaces' />;
    case DOMAIN_KEYS.em:
      return <Image className='em-logo logo' src={emLogo} alt='EM' />;
    case DOMAIN_KEYS.fba:
      return <Image className='fba-logo logo' src={fbaLogo} alt='FBA' />;
    case DOMAIN_KEYS.mh360:
      return <Image className='mh360-logo logo' src={scoutLogo} alt='SCOUT' />;
    case DOMAIN_KEYS.saq:
      return <Image className='saq-logo logo' src={SAQLogo} alt='saq' />;
    default:
      return <Image className='peer-tree-logo logo' src={isMobile ? peerTreeSmall : peerTreeLogo} alt='peer-tree' />;
  }
};

export default GetCustomersLogo;
